import { useState, useMemo } from 'react';

export const usePagination = (data = [], itemsPerPage = 20) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const [pageSize, setPageSize] = useState(itemsPerPage);

  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / pageSize);

  const paginatedData = useMemo(() => {
    if (showAll) {
      return data;
    }
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return data.slice(startIndex, endIndex);
  }, [data, currentPage, pageSize, showAll]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setShowAll(false);
  };

  const handlePageSizeChange = (newPageSize) => {
    if (newPageSize === 'all') {
      setShowAll(true);
      setPageSize(totalItems);
    } else {
      setShowAll(false);
      setPageSize(Number(newPageSize));
      setCurrentPage(1);
    }
  };

  const goToFirstPage = () => {
    setCurrentPage(1);
    setShowAll(false);
  };

  const goToLastPage = () => {
    setCurrentPage(totalPages);
    setShowAll(false);
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      setShowAll(false);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setShowAll(false);
    }
  };

  return {
    paginatedData,
    currentPage,
    totalPages,
    totalItems,
    pageSize,
    showAll,
    handlePageChange,
    handlePageSizeChange,
    goToFirstPage,
    goToLastPage,
    goToNextPage,
    goToPreviousPage,
    canPreviousPage: currentPage > 1,
    canNextPage: currentPage < totalPages,
    paginatedDataLength: paginatedData.length,
  };
};

